/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState } from 'react'
import Auth from '@aws-amplify/auth'
import { observer, inject } from 'mobx-react'
import { withRouter, RouteComponentProps, useHistory } from 'react-router-dom'
import { Theme, withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import { FaBars } from 'react-icons/fa'
import { MenuItem, ListItemIcon, Typography } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import Drift from 'react-driftjs'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import API from '@aws-amplify/api'
import { Prospects as ProspectsStore } from '../../../stores/prospects'
import { Search as SearchStore } from '../../../stores/search'
import { Related as RelatedStore } from '../../../stores/related'
import { CompanyInfo as CompanyInfoStore } from '../../../stores/companyInfo'
import { Settings as SettingsStore } from '../../../stores/settings'
import mavLogo from '../../../assets/img/white_logo.png'
import Menus from '../../../utils/menus'
import Contact from '../Settings/Contact'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
  search?: SearchStore
  related?: RelatedStore
  companyInfo?: CompanyInfoStore
  settings?: SettingsStore
  setIsAuthenticated: (isAuthenticated: boolean) => void
  title: string
}

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const Header: FC<Props> = ({
  prospects,
  search,
  related,
  companyInfo,
  settings,
  setIsAuthenticated,
  title,
}): JSX.Element => {
  const history = useHistory()
  const [isSupport, setIsSupport] = useState(false)
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const onClickMenuIcon = (option: any): void => {
    setAnchorEl(null)
    history.push(option.url)
  }

  const toHome = (): void => {
    history.push('/')
  }

  const feedback = (): void => {
    setAnchorEl(null)
    setIsFeedbackModalOpen(true)
  }

  const support = (): void => {
    setAnchorEl(null)
    setIsSupport(true)
  }

  const logout = async (): Promise<void> => {
    await Auth.signOut()

    prospects?.clearState()
    search?.clearState()
    search?.setNextToken('start')
    related?.clearState()
    companyInfo?.clearState()
    settings?.clearState()

    setIsAuthenticated(false)
    history.push('/login')
  }
  const userInfo: any = prospects?.userInfo
  const url: URL = new URL(window.location.href)
  const authCode = url.searchParams.get('code')
  if (authCode) {
    console.log({ authCode })
    const payload = {
      code: authCode,
    }

    const myInit = { body: payload }

    API.post('mav-outlook-api', '/users/grant/microsoft', myInit)
    history.push('/authorized')
  }
  if (userInfo?.emailLinked === false && !window.location.href.includes('authorize')) {
    history.push('/authorize')
  }
  if (
    userInfo?.isLicensed === false &&
    userInfo?.isAdmin === true &&
    !window.location.href.includes('crew-details')
  ) {
    history.push('/crew-details')
  }
  return (
    <div className="header">
      <div className="header-icons">
        <div className="left">
          <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <FaBars fontSize="35px" />
          </IconButton>
          <Menu id="long-menu" anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
            <MenuItem>
              <FaBars fontSize="35px" />
            </MenuItem>
            {Menus.map(option => (
              <MenuItem
                key={option.title}
                onClick={(): void => onClickMenuIcon(option)}
                className={
                  option.title === title ||
                  (title === 'Engagement Intel' && option.title === 'Intel Reports') ||
                  (title === 'Contacts' && option.title === 'Search Hangar')
                    ? 'icon-menu selected'
                    : 'icon-menu'
                }
              >
                <ListItemIcon>{option.icon}</ListItemIcon>
                <Typography variant="inherit" style={{ fontWeight: 100 }}>
                  {option.title}
                </Typography>
              </MenuItem>
            ))}
            <Divider />
            <MenuItem className="icon-menu bold" onClick={feedback}>
              Feedback
            </MenuItem>
            <Divider />
            <MenuItem className="icon-menu bold" onClick={support}>
              Support
            </MenuItem>
            <Divider />
            <MenuItem className="icon-menu bold" onClick={logout}>
              Log out
            </MenuItem>
            <Divider />
          </Menu>
          <div role="button" tabIndex={0} onKeyDown={(): void => {}} onClick={(): void => toHome()}>
            <img src={mavLogo} className="header-logo" alt="logo-img" />
          </div>
          <div className="icons-wrapper">|</div>
          <h3>
            <span>
              {`${title === 'Contacts' && userInfo?.email ? `${userInfo?.email}'s ` : ''}`}
            </span>
            <span>{`${title === 'Contacts' ? 'Hangar' : title}`}</span>
          </h3>
          {isSupport && (
            <Drift
              style={{
                bottom: '100px',
              }}
              appId="9bt2nmz7na2g"
              attributes={{ email: prospects?.userEmail }}
            />
          )}
        </div>
      </div>
      <Dialog
        onClose={(): void => setIsFeedbackModalOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={isFeedbackModalOpen}
      >
        <DialogContent dividers>
          <Contact userinfo={prospects?.userInfo} />
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default inject(
  'prospects',
  'search',
  'related',
  'companyInfo',
  'settings',
)(withRouter(observer(Header)))
